var table_viewer_default = {
  "viewMode": "_6ASqg",
  "editMode": "LtAtF",
  "container": "caZK0",
  "cell": "SEHWv"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer.scss.js.map
